import { IFacturaClienteAlumno, IInfoEmpresaFactura, IPagoInfoFacturarConceptoComplemento } from "../../../../data/entidad/Factura"
import { _SvFacturaObtenerDetalleEmpresa } from "../../../../data/modulo/FacturaEmpresa"
import _L from "../../../../util/Labels"
import { UtilObject } from "../../../../util/Object"
import { ModalThingsUtil as MTUtil } from "../../../controlD3/ModalThings/Utils"
import { NotificacionV2 } from "../../../controlD3/NotificacionV2"
import { CreateCFDISListControl } from "./FacturacionViewCFDIInfoCfdisListControl"
import { UIUtilViewAlumnoEdoCtaFacturacionViewCFDIInfoComplemento as cfdiComl } from "./FacturacionViewCFDIInfoComplemento"
import { UIUtilViewAlumnoEdoCtaFacturacionViewCFDIInfoGeneral as cfdiInfoGeneral } from "./FacturacionViewCFDIInfoGeneralForm"
import { UIUtilViewAlumnoEdoCtaFacturacionViewCFDIItem as cfdiItem } from "./FacturacionViewCFDIInfoItemForm"
import { AlumnoEdoCtaFacturacionViewMovs } from "./FacturacionViewMovs"

/**
 * Namespace que agrupa las funcionalidades relacionadas con la generación de información
 * para la creación de CFDIs (Comprobantes Fiscales Digitales por Internet).
 */
export namespace UIUtilViewAlumnoEdoCtaFacturacionViewCFDIInfo {

    export type ICFDIInfoItemFinal = ICFDIInfoGeneral & ICFDIInfoItemPreFinal
    export interface ViewInfoCFDI {
        GetData: () => ICFDIInfoItemFinal[]
        IsValid: () => boolean
        Refresh: (cliente: IFacturaClienteAlumno, gruposCFDICtrl: AlumnoEdoCtaFacturacionViewMovs) => void
    }


    /**
     * Genera la vista de información para la creación de CFDIs.
     * @param container Contenedor HTML donde se renderizará la vista.
     * @param mt Instancia del modal que contiene la vista.
     * @param idEscuela ID de la escuela asociada.
     * @param idAlumno ID del alumno asociado.
     * @returns Un objeto que implementa la interfaz `ViewInfoCFDI`.
     */
    export function _GenerarCFDI_ViewInfo(container: TSelectionHTML<"div">, mt: MTUtil.IModalThings, idEscuela: number, idAlumno: number): ViewInfoCFDI {
        // type MovimientosPagosAgrupadosControl = IMovimientosPagosAgrupados & { _FormaPago: string, _NoCuenta: string, _NoPedido: string }
        let infoEmpresaFactura: IInfoEmpresaFactura = undefined
        // let infoClienteFactura: IFacturaClienteAlumno
        const progressBar = mt.Progress.node()

        // const fnSetFormData = (data: ICFDIInfoGeneral) => formInfGral._AsignaData(data)
        const fnConsultarInfo = () => {
            let saveInfo = infoEmpresaFactura
            if (infoEmpresaFactura === null) {
                return
            }
            infoEmpresaFactura = null // null -> (consultando)
            progressBar._Visible = true
            _SvFacturaObtenerDetalleEmpresa(idEscuela)
                .then((res) => {
                    if (res.Resultado <= 0) {
                        if (saveInfo)
                            infoEmpresaFactura = saveInfo
                        return
                    }
                    infoEmpresaFactura = res.Datos
                    if (!formInfGral._GetModelValue("LugarExpedicion") || infoEmpresaFactura)
                        formInfGral._SetModelValue("LugarExpedicion", infoEmpresaFactura.codpos)
                    // console.debug("infoEmpresaFactura", infoEmpresaFactura, form)
                })
                .finally(() => {
                    progressBar._Visible = false
                })
        }

        const formInfGral = cfdiInfoGeneral._CrearInformacionGeneralForm(container, idEscuela)

        const cfdisTitle = (container.append("br"), container.append("b").text("_CFDIs a crear_"))
        const cfdisListControl = CreateCFDISListControl(idAlumno, idEscuela, container)

        fnConsultarInfo()

        return {
            GetData: () => {
                const globalData = formInfGral._Data
                return cfdisListControl._GetDataFinal().map((cfdiinfo) => {
                    const item: ICFDIInfoItemFinal = {
                        TipoCfdi: globalData.TipoCfdi,
                        LugarExpedicion: globalData.LugarExpedicion,
                        Serie: globalData.Serie,
                        MetodoPago: globalData.MetodoPago,
                        ...cfdiinfo,
                    }
                    return UtilObject._GettersSetters(item, {
                        getFecha: () => {
                            const dt: Date = new Date()
                            const dif: number = FECHA_TIMBRADO_OPCIONES_BYKEY[item.fechaTimbrado].difDays
                            dt.setDate(dt.getDate() - dif)
                            const y = dt.getFullYear()
                            const m = (dt.getMonth() + 1).toString().padStart(2, '0')
                            const d = dt.getDate().toString().padStart(2, "0")
                            // FORMATO `2020-03-20`
                            return `${y}-${m}-${d}`
                        }
                    })
                })
            },
            IsValid: () => {
                if (cfdisListControl._GetCountData() == 0) {
                    NotificacionV2._Mostrar(_L("panelfinanzasedocuenta_factura.no_cfdis_a_crear"), "ADVERTENCIA")
                    return false
                }
                const generalFormValid = formInfGral._GetIsValidForm() // Formulario general
                if (!generalFormValid) {
                    NotificacionV2._Mostrar(_L("general.notif_infofalta"), "ADVERTENCIA")
                    formInfGral._Form.node().scrollIntoView({ block: "nearest" })
                    return false
                }
                // const cfdisControls =
                for (const cfdiControls of cfdisListControl._GetControls()) {
                    if (!cfdiControls.Form._GetIsValidForm()) {
                        NotificacionV2._Mostrar(_L("general.notif_infofalta"), "ADVERTENCIA")
                        cfdiControls.Form._Form.node().scrollIntoView({ block: "nearest" })
                        return false
                    }
                    // const validCfdiClaves = [...movimientosPagosCFDIMap.values()].every(m => m.Pagos.every(p => !!p.ClaveProdServSAT)) // Conceptos con clave
                    const selectsControl = [...cfdiControls.CFDISelectProdServControls, ...cfdiControls.CFDISelectUnidadControls, ...cfdiControls.CFDIComplementoControls]
                    for (const pagoClaveControl of selectsControl) {
                        if (pagoClaveControl instanceof cfdiComl.FacturaComplementoConceptoComponent) {
                            if (pagoClaveControl._hasError) {
                                NotificacionV2._Mostrar(pagoClaveControl.getErrorMessage() || _L("panelfinanzasedocuenta_factura.compl_invalid_data"), "ADVERTENCIA")
                                pagoClaveControl.scrollIntoView({ block: "center" })
                                return false
                            }
                        }
                        else {
                            pagoClaveControl._controlSelection.style("border", "none")
                            if (!pagoClaveControl._dataSelected.length) {
                                NotificacionV2._Mostrar(_L("general.notif_infofalta"), "ADVERTENCIA")
                                const fcus = pagoClaveControl._controlSelection
                                    .style("border", "1px solid var(--color_app_red1)")
                                    .node()
                                fcus.scrollIntoView({ block: "center" })
                                fcus.click()
                                return false
                            }
                        }
                    }
                }
                return true
            },
            Refresh: (cliente: IFacturaClienteAlumno, gruposCFDICtrl: AlumnoEdoCtaFacturacionViewMovs) => {
                if (!infoEmpresaFactura) {
                    fnConsultarInfo()
                }

                // Update Movimientos
                const cfdiCount = gruposCFDICtrl.GetCFDISelectedCount();
                cfdisTitle.text(_L(cfdiCount > 1
                    ? "panelfinanzasedocuenta_factura.cfdis_a_crear"
                    : "panelfinanzasedocuenta_factura.cfdi_a_crear", cfdiCount))


                // infoClienteFactura = cliente
                gruposCFDICtrl.ConsultaCFDIConceptosFiscalesProcesados().then((gruposCFDISeleccionados) => {
                    cfdisListControl._SetData(cliente, gruposCFDISeleccionados)
                })
            }
        }
    }
}




// UTILS

const FECHA_TIMBRADO_OPCIONES_BYKEY = cfdiItem.FECHA_TIMBRADO_OPCIONES_BYKEY

type ICFDIInfoGeneral = cfdiInfoGeneral.ICFDIInfoGeneral
type ICFDIInfoItem = cfdiItem.ICFDIInfoItem

export type ICFDIInfoItemPreFinal = Pick<ICFDIInfoItem,
    | "fechaTimbrado"
    | "Fecha"
    | "UsoCFDI"
    | "FormaPago"
    | "NumOrder"
    | "CondicionPago"
    | "Cuenta"
    | "Banco"
    | "Comentarios"
    | "EnviarCorreo">
    & {
        NombreCFDI: string
        Conceptos: {
            IdsMovPagos: number[],
            ClaveProdServSAT: string
            ClaveUnidadSAT: string
            NombreUnidadSAT: string
            Complemento: IPagoInfoFacturarConceptoComplemento | undefined
        }[]
    }